import PropTypes from "prop-types"
import React from 'react';
import { Form } from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DATE_FORMAT } from 'constants/index';
import { formatDate, parseDate } from 'react-day-picker/moment';

import { ErrorPopup, WarningPopup } from "../ReduxSemanticFields";

import './day-picker.scss';

const DayPicker = (field) => {
  const { meta: { touched, error, warning }, input: { value }, required } = field;
  return (
    <Form.Field error={!!(touched && error)} required={required} >
      <label>{field.label}</label>
      <DayPickerInput
        inputProps={{ ...field.input, disabled: field.disabled }}
        value={ value }
        format={ DATE_FORMAT }
        parseDate={ parseDate }
        formatDate={ formatDate }
        placeholder={ DATE_FORMAT }
      />
      <ErrorPopup touched={touched} error={error} />
      <WarningPopup touched={touched} warning={warning} />
    </Form.Field>
  );
};

DayPicker.propTypes = {
  disabled: PropTypes.any.isRequired,
  input: PropTypes.any.isRequired,
  label: PropTypes.any.isRequired
}

export default DayPicker;
